"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxAuditErrorCodes = exports.BoxLabelIncidentErrorSubcode = exports.BoxLabelIncidentErrorCode = exports.NonComplianceErrors = exports.ReportableErrorTypes = void 0;
var ReportableErrorTypes;
(function (ReportableErrorTypes) {
    ReportableErrorTypes["WAREHOUSE_NON_EXISTANT"] = "WAREHOUSE_NON_EXISTANT";
})(ReportableErrorTypes = exports.ReportableErrorTypes || (exports.ReportableErrorTypes = {}));
var NonComplianceErrors;
(function (NonComplianceErrors) {
    NonComplianceErrors["NON_COMPLIANCE"] = "NON_COMPLIANCE";
    NonComplianceErrors["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    NonComplianceErrors["UNRECOGNIZED_ERROR"] = "UNRECOGNIZED_ERROR";
    NonComplianceErrors["NOT_FOUND_ERROR"] = "NOT_FOUND_ERROR";
    NonComplianceErrors["CDSKU_INVALID"] = "CDSKU_INVALID";
    NonComplianceErrors["ASN_INVALID"] = "ASN_INVALID";
    NonComplianceErrors["CDSKU_REQUIRED"] = "CDSKU_REQUIRED";
    NonComplianceErrors["BARCODE_INVALID"] = "BARCODE_INVALID";
    NonComplianceErrors["EMAIL_INVALID"] = "EMAIL_INVALID";
    NonComplianceErrors["INCIDENT_ALREADY_RESOLVED"] = "INCIDENT_ALREADY_RESOLVED";
})(NonComplianceErrors = exports.NonComplianceErrors || (exports.NonComplianceErrors = {}));
var BoxLabelIncidentErrorCode;
(function (BoxLabelIncidentErrorCode) {
    BoxLabelIncidentErrorCode["BARCODE_NOT_FOUND"] = "BARCODE_NOT_FOUND";
    BoxLabelIncidentErrorCode["BOX_LABEL_INCIDENT_ALREADY_SOLVED"] = "BOX_LABEL_INCIDENT_ALREADY_SOLVED";
    BoxLabelIncidentErrorCode["BOX_LABEL_INCIDENT_NOT_SOLVABLE"] = "BOX_LABEL_INCIDENT_NOT_SOLVABLE";
    BoxLabelIncidentErrorCode["CAN_NOT_CHANGE_ASN_ID"] = "CAN_NOT_CHANGE_ASN_ID";
    BoxLabelIncidentErrorCode["DSKU_NOT_FOUND"] = "DSKU_NOT_FOUND";
    BoxLabelIncidentErrorCode["INCOMPLETE_QUANTITIES_IN_BOX_LABEL_INCIDENT"] = "INCOMPLETE_QUANTITIES_IN_BOX_LABEL_INCIDENT";
    BoxLabelIncidentErrorCode["INVALID_DATA"] = "INVALID_DATA";
    BoxLabelIncidentErrorCode["NO_MATCH_FOR_BOX_INFORMATION"] = "NO_MATCH_FOR_BOX_INFORMATION";
    BoxLabelIncidentErrorCode["SELLER_MISMATCH"] = "SELLER_MISMATCH";
    BoxLabelIncidentErrorCode["SHIPPING_PLAN_HAS_NO_PACKAGES"] = "SHIPPING_PLAN_HAS_NO_PACKAGES";
    BoxLabelIncidentErrorCode["TRACKING_NUMBER_INCIDENT_MUST_HAVE_ONE_PACKAGE"] = "TRACKING_NUMBER_INCIDENT_MUST_HAVE_ONE_PACKAGE";
    BoxLabelIncidentErrorCode["UNABLE_TO_ADD_NEW_DSKUS_TO_SHIPPING_PLAN"] = "UNABLE_TO_ADD_NEW_DSKUS_TO_SHIPPING_PLAN";
    BoxLabelIncidentErrorCode["NO_MATCH_FOR_BOX_CONTENTS"] = "NO_MATCH_FOR_BOX_CONTENTS";
    BoxLabelIncidentErrorCode["UNABLE_TO_CHANGE_TO_MISSING_BOX_INFO_AFTER_BOX_INFO_ADDED"] = "UNABLE_TO_CHANGE_TO_MISSING_BOX_INFO_AFTER_BOX_INFO_ADDED";
})(BoxLabelIncidentErrorCode = exports.BoxLabelIncidentErrorCode || (exports.BoxLabelIncidentErrorCode = {}));
var BoxLabelIncidentErrorSubcode;
(function (BoxLabelIncidentErrorSubcode) {
    BoxLabelIncidentErrorSubcode["MORE_THAN_ONE_PACKAGE_GROUP_FOR_SOLVABLE_INCIDENT"] = "MORE_THAN_ONE_PACKAGE_GROUP_FOR_SOLVABLE_INCIDENT";
    BoxLabelIncidentErrorSubcode["NO_NUM_PACKAGES"] = "NO_NUM_PACKAGES";
    BoxLabelIncidentErrorSubcode["NO_SHIPPING_PLAN_ID"] = "NO_SHIPPING_PLAN_ID";
    BoxLabelIncidentErrorSubcode["NUM_PACKAGES_EXCEEDS_LABEL_LIMIT"] = "NUM_PACKAGES_EXCEEDS_LABEL_LIMIT";
})(BoxLabelIncidentErrorSubcode = exports.BoxLabelIncidentErrorSubcode || (exports.BoxLabelIncidentErrorSubcode = {}));
var BoxAuditErrorCodes;
(function (BoxAuditErrorCodes) {
    BoxAuditErrorCodes["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    BoxAuditErrorCodes["BOX_AUDIT_ONLY_AVAILABLE_AT_A_CROSSDOCK"] = "BOX_AUDIT_ONLY_AVAILABLE_AT_A_CROSSDOCK";
    BoxAuditErrorCodes["BOX_AUDIT_DOES_NOT_EXIST"] = "BOX_AUDIT_DOES_NOT_EXIST";
    BoxAuditErrorCodes["BOX_AUDIT_CANNOT_BE_MODIFIED"] = "BOX_AUDIT_CANNOT_BE_MODIFIED";
    BoxAuditErrorCodes["EMPTY_AUDIT_CANNOT_BE_RESOLVED"] = "EMPTY_AUDIT_CANNOT_BE_RESOLVED";
    BoxAuditErrorCodes["SELLER_ID_CONFLICT"] = "SELLER_ID_CONFLICT";
    BoxAuditErrorCodes["OPEN_BOX_AUDIT_IN_ANOTHER_WAREHOUSE"] = "OPEN_BOX_AUDIT_IN_ANOTHER_WAREHOUSE";
    BoxAuditErrorCodes["PALLET_SCANNED_PACKAGE_CANNOT_BE_AUDITED"] = "PALLET_SCANNED_PACKAGE_CANNOT_BE_AUDITED";
    BoxAuditErrorCodes["BARCODE_IS_KNOWN"] = "BARCODE_IS_KNOWN";
    BoxAuditErrorCodes["UNKNOWN_BARCODE_ALREADY_RECORDED"] = "UNKNOWN_BARCODE_ALREADY_RECORDED";
    BoxAuditErrorCodes["BOX_HAS_NOT_BEEN_PANDA_SCANNED"] = "BOX_HAS_NOT_BEEN_PANDA_SCANNED";
    BoxAuditErrorCodes["UNKNOWN_BARCODE_IN_BOX_BREAK_PACKAGE"] = "UNKNOWN_BARCODE_IN_BOX_BREAK_PACKAGE";
    BoxAuditErrorCodes["NO_ASN_FOUND"] = "NO_ASN_FOUND";
})(BoxAuditErrorCodes = exports.BoxAuditErrorCodes || (exports.BoxAuditErrorCodes = {}));
//# sourceMappingURL=NonComplianceErrors.js.map